import { makeStyles } from "@material-ui/core/styles";

export default makeStyles((theme) => {
  return {
    wrapperpropertyShareDocDialog: {
      display: "flex",
      flexDirection: "column",
      width: "100%",
      gap: "16px",
    },
    containerHeaderSelection: {
      display: "flex",
      flexDirection: "row",
      width: "100%",
      gap: "16px",
    },
    containerOptions: {
      display: "flex",
      flexDirection: "row",
      width: "100%",
      gap: "16px",
    },
    shareViaItem: {
      width: "100%",
      height: "102px",
      border: `1px solid ${theme.palette.border.secondary}`,
      backgroundColor: theme.palette.background.primary,
      padding: "16px",
      borderRadius: "12px",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      position: "relative",
      gap: "8px",
      cursor: "pointer",
      "&:hover": {
        border: `2px solid ${theme.palette.primary.main}`,
      },
      [theme.breakpoints.down("450")]: {
        height: "125px",
        width: "100%",
      },
    },
    selectedBox: {
      border: `2px solid ${theme.palette.primary.main}`,
    },
    checkBoxComponent: {
      position: "absolute",
      top: "0px",
      left: "0px",
      zIndex: 10,
    },
    shareViaNameOption: {
      fontWeight: 500,
      fontSize: "16px",
      lineHeight: "24px",
      color: theme.palette.text.secondary,
    },
    containerTitleFiled: {
      fontWeight: 500,
      fontSize: "16px",
      lineHeight: "24px",
      color: theme.palette.text.secondary,
      maxWidth: "280px",
      minWidth: "160px",
    },
    wrapperBodyFiled: {
      display: "flex",
      flexDirection: "column",
      gap: "16px",
    },
    containerFiledItem: {
      display: "flex",
      flexDirection: "row",
      width: "100%",
      gap: "16px",
    },
    containerSendToFiled: {
      display: "flex",
      flexDirection: "column",
      gap: "16px",
      width: "100%",
    },
  };
});
